import {
  ADD_RECEIVED_MESSAGE,
  APPLY_ARS_UPDATES,
  CLEAR_TLF,
  CLOSE_MODAL_WINDOW,
  DISCARD_ARS_UPDATES,
  ITlfAction,
  LOAD_TLF,
  PATCH_TLF_COMMENTS,
  PROCESS_SIGNALR_NOTIFICATION,
  REDO_TLF_CHANGE,
  REMOVE_TLF_COMMENT,
  SET_DELAYED_HIERARCHY_UPDATES,
  SET_EDITOR_BLOCKS_SEARCH_PANEL,
  SET_TLF_COMMENT_PANEL,
  SET_TLF_READ_ONLY,
  SET_TLF_REQUEST_STATUS,
  SET_TLF_SUBSCRIPTION_STATUS,
  SET_VIEW_MODE,
  SHOW_MODAL_WINDOW,
  TlfContextProps,
  TOGGLE_TRAFFIC_LIGHTS,
  UNDO_TLF_CHANGE,
  UPDATE_TLF,
  UPDATE_TLF_COMMENT,
} from "./interface";
import {
  tlf_addReceivedMessage,
  tlf_applyArsUpdates,
  tlf_clearTlf,
  tlf_closeModalWindow,
  tlf_discardArsUpdates,
  tlf_loadTlf,
  tlf_patchTlfComments,
  tlf_processSignalrNotification,
  tlf_redoTlfChange,
  tlf_removeTlfComment,
  tlf_setDelayedHierarchyUpdates,
  tlf_setEditorBlocksSearchPanel,
  tlf_setTlfCommentPanel,
  tlf_setTlfReadOnly,
  tlf_setTlfRequestStatus,
  tlf_setTlfSubscriptionStatus,
  tlf_setViewMode,
  tlf_showModalWindow,
  tlf_toggleTrafficLights,
  tlf_undoTlfChange,
  tlf_updateTlf,
  tlf_updateTlfComment,
} from "./tlf_functions";

/**
 * Reducer for TLF context state transitions.
 *
 * @param state - The current `TlfContextProps` state.
 * @param action - The `ITlfAction` describing the update to apply.
 * @returns The updated `TlfContextProps` after applying the action.
 */
export const tlfContextReducer = (state: TlfContextProps, action: ITlfAction): TlfContextProps => {
  switch (action.operation) {
    case ADD_RECEIVED_MESSAGE:
      return tlf_addReceivedMessage(state, action);

    case APPLY_ARS_UPDATES:
      return tlf_applyArsUpdates(state);

    case CLEAR_TLF:
      return tlf_clearTlf();

    case CLOSE_MODAL_WINDOW:
      return tlf_closeModalWindow(state);

    case DISCARD_ARS_UPDATES:
      return tlf_discardArsUpdates(state);

    case LOAD_TLF:
      return tlf_loadTlf(state, action);

    case PATCH_TLF_COMMENTS:
      return tlf_patchTlfComments(state, action);

    case PROCESS_SIGNALR_NOTIFICATION:
      return tlf_processSignalrNotification(state, action);

    case REDO_TLF_CHANGE:
      return tlf_redoTlfChange(state, action);

    case REMOVE_TLF_COMMENT:
      return tlf_removeTlfComment(state, action);

    case SET_DELAYED_HIERARCHY_UPDATES:
      return tlf_setDelayedHierarchyUpdates(state, action);

    case SET_EDITOR_BLOCKS_SEARCH_PANEL:
      return tlf_setEditorBlocksSearchPanel(state, action);

    case SET_TLF_COMMENT_PANEL:
      return tlf_setTlfCommentPanel(state, action);

    case SET_TLF_READ_ONLY:
      return tlf_setTlfReadOnly(state, action);

    case SET_TLF_REQUEST_STATUS:
      return tlf_setTlfRequestStatus(state, action);

    case SET_TLF_SUBSCRIPTION_STATUS:
      return tlf_setTlfSubscriptionStatus(state, action);

    case SET_VIEW_MODE:
      return tlf_setViewMode(state, action);

    case SHOW_MODAL_WINDOW:
      return tlf_showModalWindow(state, action);

    case TOGGLE_TRAFFIC_LIGHTS:
      return tlf_toggleTrafficLights(state, action);

    case UNDO_TLF_CHANGE:
      return tlf_undoTlfChange(state, action);

    case UPDATE_TLF:
      return tlf_updateTlf(state, action);

    case UPDATE_TLF_COMMENT:
      return tlf_updateTlfComment(state, action);

    default:
      return state;
  }
};
